// Keep-alive service to prevent server from sleeping
class KeepAliveService {
  constructor() {
    this.intervalId = null;
    this.isRunning = false;
    this.serverUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
    this.pingInterval = 14 * 60 * 1000; // 14 minutes in milliseconds
    this.lastPingTime = null;
  }

  // Start the keep-alive service
  start() {
    if (this.isRunning) {
      console.log('Keep-alive service is already running');
      return;
    }

    console.log('Starting keep-alive service...');
    this.isRunning = true;
    
    // Ping immediately when starting
    this.pingServer();
    
    // Set up interval for regular pings
    this.intervalId = setInterval(() => {
      this.pingServer();
    }, this.pingInterval);
  }

  // Stop the keep-alive service
  stop() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.isRunning = false;
    console.log('Keep-alive service stopped');
  }

  // Ping the server
  async pingServer() {
    try {
      const response = await fetch(`${this.serverUrl}/keepalive`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const data = await response.json();
        this.lastPingTime = new Date().toISOString();
        console.log('Keep-alive ping successful:', data.timestamp);
      } else {
        console.warn('Keep-alive ping failed with status:', response.status);
      }
    } catch (error) {
      console.error('Keep-alive ping error:', error.message);
    }
  }

  // Get service status
  getStatus() {
    return {
      isRunning: this.isRunning,
      serverUrl: this.serverUrl,
      pingInterval: this.pingInterval,
      lastPingTime: this.lastPingTime,
      nextPing: this.intervalId ? new Date(Date.now() + this.pingInterval).toISOString() : null
    };
  }
}

// Create singleton instance
const keepAliveService = new KeepAliveService();

export default keepAliveService;
